import React, { FC } from "react";

const HomePage: FC = () => <p>Homepage.</p>;

export default HomePage;
